export default function PHP_real_query() {
  return (
    <div>
      <h1>PHP_real_query</h1>
    </div>
  );
}
